import { useContext } from "react";
import { Link } from "react-router-dom";
import { ProfileContext } from '../context/ProfileContext';
import { IMAGE_URL } from "../API";
import Avtar from '../Assets/Images/Avatar.svg'

function Header() {
  const { personalInfo } = useContext(ProfileContext)

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-admin">
        <div className="container-fluid m-0 p-0">
          <div className="welcom-upper ms-auto d-flex">
            {/* <div className="header_search_sec">                    
                <IoSearch  className="search-icon" />
                <Form.Group className="comn-class-inputs" >
                    <Form.Control type="text" placeholder="Search Here..." />
                </Form.Group>       
            </div> */}
            <div className="d-flex header_user_info_row">
              <Link to="/profile" className="header_user_img">
                <img src={personalInfo?.image ? IMAGE_URL + personalInfo?.image : Avtar} alt="Profile" className="img-fluid" />
              </Link>
              <div className="contnt">
                <h6>{personalInfo?.name}</h6>
                <h5>{personalInfo?.role}</h5>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
